import { getChannels, getChannelGenres } from "./ltv";
import { readCache } from "../../utils/readCache";
import { filterChannelsByGenre } from "../../utils/channelGenreFilter";

// Keep the current Live TV screen while using the original genre/channel APIs.
export const getLiveCategories = () =>
  readCache.read("legacy:live-genres", getChannelGenres, 300000);

export const getLiveCategoryChannels = async (categoryId) => {
  if (!categoryId) throw new Error("Live category is required");
  const [response, categories] = await Promise.all([
    getChannels(),
    getLiveCategories()
  ]);
  const category = categories.find(
    (item) => String(item.id) === String(categoryId)
  );
  if (!category) throw new Error("Live category not found");
  return { ...response, data: filterChannelsByGenre(response.data, category) };
};

export const getLiveChannelById = async (channelId) => {
  const response = await getChannels();
  const channel = response.data.find(
    (item) => String(item.id) === String(channelId)
  );
  if (!channel) throw new Error("Channel not found");
  return channel;
};
